export default "__VITE_ASSET__P_G1p3Qg__"